function getPrescriptionEntryList(prescriptionStepEntryTypes) {
    if (!prescriptionStepEntryTypes || prescriptionStepEntryTypes.length === 0) {
        return undefined;
    }
    return prescriptionStepEntryTypes.map((item)=>{
        var ref, ref1;
        return {
            key: item.key,
            title: item.iconTextCompound[0].text,
            icon: !!((ref = item.iconTextCompound[0]) === null || ref === void 0 ? void 0 : ref.icon) ? (ref1 = item.iconTextCompound[0]) === null || ref1 === void 0 ? void 0 : ref1.icon : undefined,
            description: !!item.description.value ? item.description.value : undefined,
            ctaLabel: !!item.ctaLabel ? item.ctaLabel : undefined
        };
    });
}

export { getPrescriptionEntryList };
//# sourceMappingURL=get-prescription-entry-list.js.map
